import Inputs from 'components/Inputs'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const MultiInputQuestion = ({
  data,
  question_frame,
  onChange,
  answers,
  inverted = false,
  questionNumber = 0,
}: {
  data: Question[]
  question_frame: Question
  onChange: (
    id: string,
    value: string | number,
    questionNumber?: number
  ) => void
  answers: (string | number | undefined)[]
  inverted?: boolean
  questionNumber?: number
}) => {
  const [answered, setAnswered] = useState(
    answers.map((a) => (a ? true : false))
  )

  const [subAnswers, setSubAnswers] = useState<
    { id: string; value: string | number }[]
  >(
    answers
      ? (answers
          .map((a, i) => ({
            id: data[i].id,
            value: a,
          }))
          .filter((f) => f.value) as { id: string; value: string | number }[])
      : []
  )
  const handleAnswer = (
    id: string,
    value: string | number,
    _?: number,
    pos?: number
  ) => {
    const qnum=data.find((d)=>d.id===id)
    const newanswered = answered.map((a, i) => (i === pos ? true : a))
    onChange(id, value, 25)
    setAnswered(newanswered)
    setSubAnswers([...subAnswers, { id, value }])
  }

  useEffect(() => {
    if (subAnswers.length === 3) {
      onChange('group_agree', 'answered', questionNumber)
    }
  }, [subAnswers.length])

  // },[answers])
  // useEffect(() => {
  //   if (answers.filter((f) => f).length === data.length) {
  //   } else {
  //     subAnswers.map((a) => {
  //       onChange(a.id, a.value, 0)
  //     })
  //   }
  // }, [subAnswers])

  return (
    <QuestionRoot id={'q' + questionNumber}>
      <Title>
        <QuestionNumber
          style={{
            color:
              answered.filter((f) => f).length === data.length
                ? 'var(--purple-main)'
                : 'unset',
            fontSize:
              answered.filter((f) => f).length === data.length
                ? '22px'
                : '14px',
          }}
        >
          {answered.filter((f) => f).length === data.length ? (
            <>&#10003;</>
          ) : (
            questionNumber
          )}
        </QuestionNumber>{' '}
        {question_frame.question}
      </Title>
      <>
        {data &&
          data.map((d, i) => {
            return (
              <Inputs
                key={d.id}
                inverted={inverted}
                questiondata={d}
                onChange={(
                  id: string,
                  value: string | number,
                  questionNumber?: number
                ) => {
                  answers[i] = value
                  handleAnswer(id, value, questionNumber, i)
                }}
                value={answers[i]}
                title={d.question}
              />
            )
          })}
      </>
      {/*   */}
    </QuestionRoot>
  )
}
const QuestionNumber = styled.div`
  font-weight: 300;
  font-size: 15px;
  float: left;
  margin-right: 5px;
  position: relative;
  width: 26px;
  text-align: center;
`
const QuestionRoot = styled.div`
  margin-bottom: 90px;
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 30;
  small {
    font-weight: 300;
    font-size: 15px;
  }
`

const Title = styled.h3`
  line-height: 1.2em;
  font-size: 18px;
  @media screen and (max-width: 712px) {
    font-size: 18px;
  }
`
export default MultiInputQuestion
